import { DataRow } from './DataRow';

import { useSelector } from 'react-redux';
import { selectClient } from '@client/model';
import { usePolicyInsightContext } from './PolicyInsight';

import { formatCurrencyValue } from './policyInsightUtils';

export function LtcPayoutSummary() {
  const client = useSelector(selectClient);
  const { insightData } = usePolicyInsightContext();

  const { clientFirstName } = client;

  const earlyCarePhase = insightData?.earlyCarePhase;
  const moderateCarePhase = insightData?.moderateCarePhase;
  const fullCarePhase = insightData?.fullCarePhase;
  const totalPolicyCoverage = insightData?.totalPolicyCoverage;

  return (
    <section>
      <h2 className="mb-2 text-lg font-semibold text-gray-950">Long-Term Care Payout Summary</h2>
      <div className="space-y-4 rounded-xl border border-gray-200 p-4">
        <p className="mb-4 text-sm italic text-gray-700">
          The long-term care payout is the total projected coverage all care phases for{' '}
          {clientFirstName}. Based on our calculations, the policy terms indicate that this policy
          is expected to pay out:
        </p>
        <hr className="border-gray-200" />
        <div className="space-y-4">
          <DataRow label="Early Care Phase">{formatCurrencyValue(earlyCarePhase)}</DataRow>
          <DataRow label="Moderate Care Phase">{formatCurrencyValue(moderateCarePhase)}</DataRow>
          <DataRow label="Full Care Phase">{formatCurrencyValue(fullCarePhase)}</DataRow>
          <hr className="border-gray-200" />
          <DataRow
            highlight="green"
            label="Total policy coverage"
          >
            {formatCurrencyValue(totalPolicyCoverage)}
          </DataRow>
        </div>
      </div>
    </section>
  );
}
